module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/provider/provider-registration.component.css
// module id = ./src/app/views/provider/provider-registration.component.css
// module chunks = main